module.exports = __webpack_public_path__ + "44a5ece9b6909882d8cada53933a52a9.svg";